import React from 'react';
import { useEffect, useRef } from 'react';
import CapRow from '../../CapRow';
import CapIcon from '../../CapIcon';
import CapLink from '../../CapLink';
import CapTooltip from '../../CapTooltip';
import CapHeader from '../../CapHeader';

import hljs from 'highlight.js/lib/core';
import sql from 'highlight.js/lib/languages/sql';
import { format } from 'sql-formatter';
import 'highlight.js/styles/felipec.css';
import CapLabel from '../../CapLabel';

import { clsPrefix } from './constants';

hljs.registerLanguage('sql', sql);

export const ErrorDataBlock = ({ title, desc, link, linkMsg, type }) => {
  const openFTPLink = link => {
    window.open(link, '_blank', 'noreferrer');
  };
  return (
    <div
      className={`${clsPrefix}-error-data-block ${type === 'PI' && 'pi-block'}`}
    >
      <>
        <CapIcon type={type === 'PI' ? 'eye-invisible' : 'warning'} />
        <CapHeader size="regular" title={title} description={desc} />
      </>
      {link && <CapLink onClick={() => openFTPLink(link)} title={linkMsg} />}
    </div>
  );
};

export const ChartEmptyBlock = ({ title, desc, chartIcon }) => {
  return (
    <div className={`${clsPrefix}-chart-empty-block`}>
      <>
        {chartIcon && (
          <CapIcon type="growth-graph" style={{ fontSize: '8.75rem' }} />
        )}
        <CapHeader size="regular" title={title} description={desc} />
      </>
    </div>
  );
};

export const RefreshBtn = ({ refreshData }) => {
  return (
    <CapTooltip title="Refresh Data">
      <CapIcon
        type="refresh"
        size="s"
        withBackground={true}
        className={`${clsPrefix}-refresh-data`}
        onClick={refreshData}
      />
    </CapTooltip>
  );
};

export const SQLBlock = ({ query = '' }) => {
  const codeRef = useRef(null);
  const formattedQuery = format(query, { language: 'mysql' });
  useEffect(() => {
    hljs.highlightBlock(codeRef.current);
  }, []);
  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(query);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <pre>
        <code className="sql" ref={codeRef}>
          {formattedQuery}
        </code>
      </pre>
      <CapIcon
        type="copy"
        size="s"
        className={`${clsPrefix}-refresh-data`}
        withBackground={true}
        onClick={handleCopyClick}
      />
    </div>
  );
};
export const MessageBlock = ({ message, showModal, handleModify }) => {
  const {
    id = '',
    prompt = '',
    status = '',
    query,
    interpretation = '',
  } = message;
  return (
    <>
      <CapRow className={`${clsPrefix}-message-sent`}>{prompt}</CapRow>
      {status === 'PROMPT' ? (
        <CapRow type="flex" align="middle" style={{ gap: '0.5rem' }}>
          <CapIcon type="loading" style={{ fontSize: '1.5rem' }} />
          <CapLabel type="label16">Generating Results</CapLabel>
        </CapRow>
      ) : (
        status === 'QUERY' && (
          <>
            <CapRow className={`${clsPrefix}-message-received`}>
              {interpretation}
              {query && (
                <CapTooltip
                  title="Modify this Query"
                  getPopupContainer={() =>
                    document.querySelector(`.${clsPrefix}-root`)
                  }
                  mouseLeaveDelay={0}
                >
                  <CapIcon
                    type="calendar-active"
                    size="s"
                    className={`${clsPrefix}-message-modify`}
                    onClick={() => handleModify(id)}
                    data-testid="modify-query"
                  />
                </CapTooltip>
              )}
            </CapRow>
            {query && (
              <CapRow type="flex" style={{ gap: '4px' }}>
                <CapLabel type="label16">The Response is Ready!</CapLabel>
                <CapLink
                  onClick={() => showModal(id)}
                  className={`${clsPrefix}-link-resp`}
                  title={
                    <CapRow type="flex" align="middle">
                      Check the Results!
                      <CapIcon
                        style={{ fontSize: '14px' }}
                        type="open-in-new-light"
                      />
                    </CapRow>
                  }
                />
              </CapRow>
            )}
          </>
        )
      )}
    </>
  );
};
